import React from "react";
import { PropelSpinLoader } from "./SpinLoader.styles";
import { SpinLoaderProps } from "./SpinLoader.types";

export const SpinLoader = ({ color, type }: SpinLoaderProps) => {
  const renderBounce = () => (
    <PropelSpinLoader color={color} type={type}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </PropelSpinLoader>
  );
  return renderBounce();
};
